export class GetCoverImageModel {
  public name!: string;
  public content!: string;
}
